<template>
    <!-- component -->
    <div class="flex justify-center my-6">
        <div class="flex flex-col w-full p-4 md:p-8 text-gray-800 bg-white shadow-lg pin-r pin-y md:w-11/12 lg:w-4/5">
            <div v-show="errors?.panier_expire" class="w-screen max-w-lg bg-red-200 mx-auto mt-6 p-2">
                <div class="flex space-x-2">
                    <svg class="w-6 h-6 stroke-red-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    <p class="text-red-900 font-semibold" v-html="__('panier_a_expire')"></p>
                </div>
                <p class="ml-8 text-red-800" v-html="__('panier_expiration_message')"></p>
            </div>
            <template v-if="!panier || panier.length === 0">
                <p class="text-center font-bold">{{ __('panier_est_vide') }}</p>
            </template>
            <template v-else>
                <div class="flex-1">
                    <table class="w-full text-sm lg:text-base">
                        <thead>
                            <tr class="h-12 uppercase text-lg">
                                <th class="text-left">{{ __('Produit') }}</th>
                                <th class="text-center">{{ __('Total') }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-b-2 border-gray-100" v-for="item in panier">
                                <td class="py-4">
                                    <template v-if="item.attributes.categorie.par_combinaison">
                                        <p class="font-bold text-cavilam-primary" v-html="__(item.attributes.categorie.slug)"></p>
                                        <div v-for="(programme, key) in item.attributes.programmes">
                                            <p class="font-bold" v-if="key < 1">{{ __('module_matin') }}</p>
                                            <p class="font-bold" v-else>{{ __('module_apres_midi') }}</p>
                                            <p class="text-sm">{{ __(programme.produit.slug) }} <span v-if="item.attributes.niveau"> - {{ __(item.attributes.niveau.constante) }}</span></p>
                                            <p v-if="key >= 1" class="ml-2 text-gray-700 text-sm">
                                                <template v-if="programme.produit.par_semaines">
                                                    <span  v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                                </template>
                                                <template v-else-if="!programme.date_fin">
                                                    <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                                </template>
                                                <template v-else>
                                                    <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                                </template>
                                            </p>
                                        </div>
                                    </template>
                                    <template v-else-if="item.attributes.produit.enfants && item.attributes.produit.enfants.length">
                                        <p class="font-bold text-cavilam-primary">
                                            <span v-html="__(item.attributes.produit.slug)"></span>
                                            <span v-if="item.attributes.niveau"> - {{ __(item.attributes.niveau.constante) }}</span>
                                        </p>
                                        <div v-for="(programme, key) in item.attributes.programmes">
                                            <p class="ml-2 text-gray-700" v-if="!key">
                                                <template v-if="programme.produit.par_semaines">
                                                    <span v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                                </template>
                                                <template v-else-if="!programme.date_fin">
                                                    <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                                </template>
                                                <template v-else>
                                                    <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                                </template>
                                                <template v-if="programme.produit.par_semaines">
                                                    - {{ __('Duree_de_formation') }} : {{ item.quantity }}
                                                    <span v-if="programme.produit.type_quantite === 'semaine'">{{ __('semaines') }}</span>
                                                    <span v-else>{{ __('lecons') }}</span>
                                                </template>
                                            </p>
                                            <!-- <p class="my-1" v-if="!key" v-html="__('modules_choisis')"></p> -->
                                            <p class="text-sm" v-if="!key || (item.attributes.programmes[key-1].produit.slug !== programme.produit.slug)"><span v-html="__(programme.produit.slug)"></span></p>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-for="(programme, key) in item.attributes.programmes">
                                            <p class="font-bold text-cavilam-primary" v-if="!key || (item.attributes.programmes[key-1].produit.slug !== programme.produit.slug)">
                                                <span v-html="__(programme.produit.slug)"></span>
                                                <span v-if="item.attributes.niveau"> - {{ __(item.attributes.niveau.constante) }}</span>
                                            </p>
                                            <p class="ml-2 text-gray-700">
                                                <template v-if="programme.produit.par_semaines">
                                                   <span v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                                </template>
                                                <template v-else-if="!programme.date_fin">
                                                   <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                                </template>
                                                <template v-else>
                                                   <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                                </template>
                                                <template v-if="programme.produit.par_semaines">
                                                   - {{ __('Duree_de_formation') }} : {{ item.quantity }}
                                                   <span v-if="programme.produit.type_quantite === 'semaine'">{{ __('semaines') }}</span>
                                                   <span v-else>{{ __('lecons') }}</span>
                                                </template>
                                            </p>
                                        </div>
                                    </template>
                                    <div v-for="detail in item.attributes.produit.details"
                                         class="ml-4 flex text-sm text-gray-600">
                                        <template v-if="montrerDetail(detail, item.attributes.etapes)">
                                            <p class="w-5/6 italic" v-html="__(detail.detail)"></p>
                                            <p class="w-1/6 text-center italic">{{ detail.prix }} €</p>
                                        </template>
                                    </div>
                                    <template v-if="item.attributes.etapes && Object.keys(item.attributes.etapes).length">
                                        <button class="font-semibold text-cavilam-secondary" @click="voirOptions(item.id)">{{ __('voir_options_prises') }}</button>
                                        <div v-show="affichageOptions === item.id">
                                            <template v-for="etape in item.attributes.etapes">
                                                <div class="mt-2">
                                                    <h2 class="font-bold uppercase" v-html="__('etape_'+etape.nom)"></h2>
                                                    <p v-if="etape.options.length || Object.keys(etape.options).length" v-for="option in etape.options">
                                                        <template v-if="option && option.valeur && Object.keys(option.valeur).length && option.valeur">
                                                            <span class="font-semibold text-sm" v-if="__(option.libelle)" v-html="'- '+__(option.libelle)"></span>
                                                            <br v-if="__(option.libelle)" />
                                                            <div v-if="Array.isArray(option.valeur)">
                                                                <span v-for="(valeur, index) in option.valeur" :key="index" class="text-xs" v-html="__(valeur.name) + ', '"></span>
                                                            </div>
                                                            <span v-else-if="option.valeur.value" class="text-xs" v-html="__(option.valeur.value)"></span>
                                                            <span v-else class="text-xs" v-html="__(option.valeur)"></span>
                                                        </template>
                                                    </p>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </td>
                                <td class="w-1/6 py-4 text-center">
                                    <span class="text-cavilam-primary text-sm lg:text-base font-semibold">
                                        {{ montantItem(item.id) }} €
                                    </span>
                                </td>
                                <td class="w-1/6 py-4 text-right">
                                    <span @click="removeItem(item.id)"
                                                  as="button"
                                                  class="text-red-600 md:ml-4 hover:text-red-400 cursor-pointer">
                                        <i class="fas fa-trash-alt text-2xl"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="my-4 mt-6 -mx-2 lg:flex">
                        <div class="lg:px-2 lg:w-1/2">
                            <div class="p-4 bg-gray-100 rounded-full">
                                <h1 class="ml-2 font-bold uppercase">{{ __('Actions') }}</h1>
                            </div>
                            <div class="p-4">
                                <p>
                                    <inertia-link class="w-full inline-flex items-center px-4 py-2 bg-cavilam-secondary border border-transparent rounded-md font-semibold text-base text-white uppercase tracking-widest hover:bg-green-300 active:bg-greeb-700 focus:outline-none focus:border-gray-3 focus:shadow-outline-gray transition ease-in-out duration-150"
                                    :href="route('inscription')">
                                        <i class="fas fa-store"></i> &nbsp;
                                        {{ __('Continuer_mes_achats') }}
                                    </inertia-link>
                                </p>
                                <p>
                                    <span class="mt-5 w-full inline-flex items-center px-4 py-2 bg-red-500 border border-transparent rounded-md font-semibold text-base text-white uppercase tracking-widest hover:bg-red-400 active:bg-gray-300 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 cursor-pointer"
                                    as="button"
                                    @click="viderPanier"
                                    >
                                        <i class="fas fa-trash"></i> &nbsp;
                                        {{ __('Vider_le_panier') }}
                                    </span>
                                </p>
                            </div>
                            <!--<div class="p-4 mt-6 bg-gray-100 rounded-full">
                                <h1 class="ml-2 font-bold uppercase">{{ __('Code_promo') }}</h1>
                            </div>-->
                            <div class="p-4">
                                <p class="mb-4 italic">{{ __('si_vous_avez_un_code_promo_renseignez_le_ici') }}</p>
                                <div class="justify-center md:flex">
                                    <form @submit.prevent="addCodePromo">
                                        <div class="flex items-center w-full pl-2 bg-white bg-gray-100 border rounded-full">
                                            <input v-model="form.code_promo" type="text" name="code" :placeholder="__('ajouter_code')"
                                                   class="rounded-full w-full bg-gray-100 border-0 outline-none appearance-none focus:outline-none active:outline-none"/>
                                            <button type="submit"
                                                    class="inline-flex items-center px-4 py-3 bg-cavilam-primary border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150">
                                                <i class="fas fa-gift"></i> &nbsp;
                                                <span class="font-medium">{{ __('Valider') }}</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <div class="text-red-600 text-center" v-if="errors.promo">{{ __(errors.promo) }}</div>
                            </div>
                        </div>
                        <div class="lg:px-2 lg:w-1/2">
                            <div class="p-4 bg-gray-100 rounded-full">
                                <h1 class="ml-2 font-bold uppercase">{{ __('Detail_du_panier') }}</h1>
                            </div>
                            <div class="p-4">
                                <div class="flex justify-between border-b">
                                    <div class="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                        {{ __('Sous_total') }}
                                    </div>
                                    <div class="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                        {{ montantSousTotal }} €
                                    </div>
                                </div>
                                <div v-if="promo && Object.keys(promo).length && promo.constructor === Object" class="flex justify-between pt-4 border-b">
                                    <div class="flex lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-gray-800">
                                        <inertia-link method="delete" preserve-scroll as="button"
                                            :href="route('panier.remove.promo')"
                                            class="mr-2">
                                            <svg aria-hidden="true" data-prefix="far" data-icon="trash-alt" class="w-4 text-red-600 hover:text-red-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M268 416h24a12 12 0 0012-12V188a12 12 0 00-12-12h-24a12 12 0 00-12 12v216a12 12 0 0012 12zM432 80h-82.41l-34-56.7A48 48 0 00274.41 0H173.59a48 48 0 00-41.16 23.3L98.41 80H16A16 16 0 000 96v16a16 16 0 0016 16h16v336a48 48 0 0048 48h288a48 48 0 0048-48V128h16a16 16 0 0016-16V96a16 16 0 00-16-16zM171.84 50.91A6 6 0 01177 48h94a6 6 0 015.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0012-12V188a12 12 0 00-12-12h-24a12 12 0 00-12 12v216a12 12 0 0012 12z"/></svg>
                                        </inertia-link>
                                        <div>
                                            {{ __(promo.constante) }}
                                            <p v-if="!promo.eligible" class="text-xs w-full text-red-500">
                                                {{ __('aucun_produit_eligible') }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-green-700">
                                        - {{ montantReduction }} €
                                    </div>
                                </div>
                                <div class="relative flex justify-between pt-4 border-b" :class="{'text-red-700': free_frais_inscription}">
                                    <div class="flex lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-gray-800" :class="{'text-red-700': free_frais_inscription}">
                                        {{ __('frais_inscription') }}
                                    </div>
                                    <div class="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center">
                                        <div v-if="promo && Object.keys(promo).length && promo.constructor === Object && (promo.frais_inscription != undefined || promo.frais_inscription != null)">
                                            <span v-if="promo.frais_inscription > 0.0"> {{ promo.frais_inscription }} €</span>
                                            <span class="uppercase font-semibold" v-else>{{ __('Gratuit') }}</span>
                                        </div>
                                        <div v-else>
                                            {{ fraisInscription }} €
                                        </div>
                                    </div>
                                    <div class="absolute h-0.5 w-full bg-red-700 top-3/5" v-if="free_frais_inscription"></div>
                                </div>
                                <div v-if="frais_transfert" class="flex justify-between pt-4 border-b">
                                    <div class="flex lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-gray-800">
                                        {{ __('frais_transfert') }}
                                    </div>
                                    <div class="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center">
                                        <div>
                                            {{ fraisTransfert }} €
                                        </div>
                                    </div>
                                </div>
                                <div class="flex justify-between pt-4 border-b">
                                    <div class="lg:px-4 lg:py-2 m-2 text-lg lg:text-xl font-bold text-center text-gray-800">
                                        {{ __('Total') }}
                                    </div>
                                    <div class="lg:px-4 lg:py-2 m-2 lg:text-lg font-bold text-center text-gray-900">
                                        {{ montantTotal }} €
                                    </div>
                                </div>
                                <span @click="beginCheckout"
                                    class="mt-10 w-full inline-flex items-center px-4 py-2 bg-cavilam-primary border border-transparent rounded-md font-semibold text-base text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 cursor-pointer"
                                    id="TM-init-checkout"
                                    >
                                    <i style="font-size: 1.2em;" class="fas fa-credit-card"></i>
                                    <span class="ml-2 mt-5px">{{ __('continuer_au_paiement') }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import App from '@/Layouts/App'

export default {
    name: "Panier",
    layout: App,
    data() {
        return {
            form: this.$inertia.form({
                code_promo: '',
            }),
            affichageOptions: '',
            free_frais_inscription: false, // Temperaire -- 21/04/2025 - 04/05/2025
        }
    },
    props: {
        panier: Object,
        promo: Object,
        frais_inscription: Number,
        frais_transfert: Number,
        errors: Object,
    },
    methods: {
        voirOptions(id) {
            if(this.affichageOptions !== id)
                this.affichageOptions = id;
            else
                this.affichageOptions = '';
        },
        montrerDetail(detail, etapes) {

            if(etapes && Object.keys(etapes).length && detail && detail.conditions && detail.conditions.length) {
                for(let condition in detail.conditions) {
                    let found = false;

                    for(let etape in etapes) {
                        for(let option in etapes[etape].options) {
                            if(detail.conditions[condition].parent_option_id === etapes[etape].options[option].valeur.option_id) {
                                if(detail.conditions[condition].enfant_option_id !== etapes[etape].options[option].valeur.id)
                                    return false;

                                found = true;
                            }
                            if(found) break;
                        }
                        if(found) break;
                    }
                }
            }

            return true;
        },
        addCodePromo() {
            this.form
                .transform(data => ({
                    ... data, ...{ preserveScroll: true }
                }))
                .post(this.route('panier.add.promo'))
        },
        montantItem: function (id) {
            let prix = parseFloat(0);
            prix += parseFloat(this.panier[id].price);
            prix += parseFloat(this.montantOptions(id));
            return parseFloat(prix).toFixed(2);
        },
        montantOptions(id) {
            let prix = parseFloat(0);
            for(let etape in this.panier[id].attributes.etapes) {
                let elemEtape = this.panier[id].attributes.etapes[etape];

                // Les frais de transferts seront à régler sur place
                if (elemEtape.nom === 'transfert') continue;

                for(let option in elemEtape.options) {

                    if(!elemEtape.options[option] || !elemEtape.options[option].valeur || typeof elemEtape.options[option].valeur !== 'object' || !elemEtape.options[option].valeur.montant)
                        continue;

                    if(elemEtape.options[option].valeur.type === 'number') {
                        prix += parseFloat(elemEtape.options[option].valeur.montant) * parseFloat(elemEtape.options[option].valeur.value);
                    } else {
                        prix += parseFloat(elemEtape.options[option].valeur.montant);
                    }

                }
            }
            return parseFloat(prix).toFixed(2);
        },
        removeItem(id) {
            this.TM_remove_from_cart([id]);
            this.$inertia.delete(route('panier.delete', id));
        },
        viderPanier() {
            this.TM_remove_from_cart();
            this.$inertia.delete(route('panier.empty'));
        },
        beginCheckout() {
            this.TM_begin_checkout();
            this.$inertia.visit(route('paiement.donneesPersonnelles'));
        },

        // #region Google Analytics (Tag Manager)
        TM_remove_from_cart(ids = []) {
            let items = [];

            // Si vide on enleve tout
            if (!ids.length) items = this.TM_get_items();
            else { // Sinon on enleve juste les items selectionnés
                for(let id of ids) {
                    let item = this.panier[id];
                    let tarif = item.attributes.produit.tarifs.find(tarif => {
                        return tarif.annee == (new Date()).getFullYear();
                    });
                    if (!tarif) tarif = item.attributes.produit.tarifs[0];
    
                    items.push({
                        item_id: item.attributes.produit.id,
                        item_name: this.__(item.attributes.produit.slug),
                        item_category: this.__(item.attributes.categorie.slug),
                        item_list_id: item.attributes.categorie.id,
                        item_list_name: this.__(item.attributes.categorie.slug),
                        price: tarif.montant,
                        quantity: item.quantity,
                    });
                }
            }

            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    currency: "EUR",
                    value: this.montantSousTotal,
                    items: items
                }
            });
        },
        TM_begin_checkout() {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    currency: "EUR",
                    value: this.montantSousTotal,
                    items: this.TM_get_items()
                }
            });
        },
        TM_get_items() {
            let items = [];
            for(let itemId in this.panier) {
                let item = this.panier[itemId];
                let tarif = item.attributes.produit.tarifs.find(tarif => {
                    return tarif.annee == (new Date()).getFullYear();
                });
                if (!tarif) tarif = item.attributes.produit.tarifs[0];

                items.push({
                    item_id: item.attributes.produit.id,
                    item_name: this.__(item.attributes.produit.slug),
                    item_category: this.__(item.attributes.type.slug),
                    item_list_id: item.attributes.categorie.id,
                    item_list_name: this.__(item.attributes.categorie.slug),
                    price: tarif.montant,
                    quantity: item.quantity,
                });
            }
            return items;
        },
        // #endregion Google Analytics (Tag Manager)

    },
    computed: {
        montantSousTotal() {
            let prix = parseFloat(0);
            for(let itemId in this.panier) {
                prix += parseFloat(this.montantItem(itemId));
            }
            return parseFloat(prix).toFixed(2);
        },
        montantReduction() {
            if(this.promo && Object.keys(this.promo).length && this.promo.constructor === Object)
                return parseFloat(parseFloat(this.promo.montant)).toFixed(2);
            else
                return parseFloat(0).toFixed(2)
        },
        fraisInscription() {
            if(this.promo && Object.keys(this.promo).length && this.promo.constructor === Object && (this.promo.frais_inscription != undefined || this.promo.frais_inscription != null))
                return parseFloat(parseFloat(0) + parseFloat(this.promo.frais_inscription)).toFixed(2);
            else
                return parseFloat(parseFloat(0) + parseFloat(this.frais_inscription)).toFixed(2);
        },
        fraisTransfert() {
            if (!this.frais_transfert) return 0;
            return parseFloat(this.frais_transfert).toFixed(2);
        },
        montantTotal() {
            if (this.free_frais_inscription) {
                return parseFloat((parseFloat(this.montantSousTotal) + parseFloat(this.fraisTransfert)) - parseFloat(this.montantReduction)).toFixed(2);
            }
            return parseFloat((parseFloat(this.fraisInscription) + parseFloat(this.montantSousTotal) + parseFloat(this.fraisTransfert)) - parseFloat(this.montantReduction)).toFixed(2);
        }
    },
    mounted() {
        let date = new Date();
        let start = new Date("2025-04-22");
        let end = new Date("2025-05-04");

        if (date >= start && date <= end) {
            for (let itemID in this.panier) {
                let item = this.panier[itemID];
    
                if (item.attributes.categorie.type_id == 2) {
                    this.free_frais_inscription = true;
                    break;
                }
            }
        }

        // #region Google Analytics (Tag Manager) 
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "view_cart",
            ecommerce: {
                currency: "EUR",
                value: this.montantSousTotal,
                items: this.TM_get_items()
            }
        });
        // #endregion Google Analytics (Tag Manager) 
    }
}
</script>

<style scoped>
.top-3\/5 {
    top: 60%;
}
</style>
